// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__1c4Gq","info":"Note_info__2x047","note":"Note_note__k-RTN","actions":"Note_actions__2blnK"};